export default __webpack_public_path__ + "static/mitsubishi-melf-9b5317f48892cb28b5b3cc2e0ffa0a40.jpg";